import { getSpace } from '../../../foundation/theme/space.utils';
import { getFontSize, getFontWeight } from '../../../foundation/theme/typography.utils';
import tokens from '../../../foundation/tokens/js/tokens';
// Constants.
// -----------------------------------------------------------------------------
export const BASE_INPUT_DEFAULT_DISABLE = false;
export const BASE_INPUT_DEFAULT_MODE = 'light';
export const BASE_INPUT_DEFAULT_SIZE = 's';
export const BASE_INPUT_DEFAULT_ROLE = 'none';
export const BASE_INPUT_DEFAULT_WIDTH = '100%';
/** Mode mappings */
export const MAPPINGS_MODE = {
    // Dark mode.
    dark: {
        background: tokens.colors.black[100].value,
        border: tokens.colors.midnight[700].value,
        placeholder: tokens.colors.midnight[700].value,
        text: tokens.colors.midnight[300].value,
        disabled: {
            background: tokens.colors.midnight[850].value,
            border: tokens.colors.midnight[800].value,
            text: tokens.colors.midnight[800].value
        },
        focus: {
            border: tokens.colors.midnight[850].value,
            shadow: `0 0 0 4px ${tokens.colors.midnight[150].value}`
        },
        hover: {
            border: tokens.colors.midnight[400].value
        },
        selection: {
            background: tokens.colors.navy[200].value,
            color: tokens.colors.navy[800].value
        }
    },
    // Light mode.
    light: {
        background: tokens.colors.white[100].value,
        border: tokens.colors.midnight[200].value,
        placeholder: tokens.colors.midnight[300].value,
        text: tokens.colors.midnight[800].value,
        disabled: {
            background: tokens.colors.midnight[150].value,
            border: tokens.colors.midnight[200].value,
            text: tokens.colors.midnight[800].value
        },
        focus: {
            border: tokens.colors.midnight[850].value,
            shadow: `0 0 0 4px ${tokens.colors.midnight[150].value}`
        },
        hover: {
            border: tokens.colors.midnight[400].value
        },
        selection: {
            background: tokens.colors.navy[200].value,
            color: tokens.colors.navy[800].value
        }
    }
};
/** Scale mappings. */
export const MAPPINGS_SCALE = {
    s: {
        fontSize: getFontSize('s'),
        fontWeight: getFontWeight('medium'),
        padding: getSpace('xl')
    },
    xs: {
        fontSize: getFontSize('s'),
        fontWeight: getFontWeight('medium'),
        padding: `${getSpace('s')} ${getSpace('m')}`
    }
};
//# sourceMappingURL=BaseInput.constants.js.map